import { render } from "./AvaLeht.vue?vue&type=template&id=20817806&scoped=true&ts=true"
import script from "./AvaLeht.vue?vue&type=script&lang=ts"
export * from "./AvaLeht.vue?vue&type=script&lang=ts"

import "./AvaLeht.vue?vue&type=style&index=0&id=20817806&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20817806"]])

export default __exports__